import { useClientAccountOverview } from '@ukpostbox/client-data';
import { useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { EndpointError } from '../../_Global/Components/EndpointError';
import { LockedMailIssueEntry } from './Entries/LockedMailIssueEntry';
import { PendingStorageChargeIssueEntry } from './Entries/PendingStorageChargeIssueEntry';
import { ForwardingBatchesIssueEntry } from './Entries/ForwardingBatchesIssueEntry';

function AccountIssues() {
	const { t } = useTranslation();
	const { data, status, error } = useClientAccountOverview();

	return (
		<>
			{status === 'error' && <EndpointError {...error} />}

			<div className='round-shadow'>
				<div
					className={`account-issues-container account-issue-highlight ${status !== 'pending' && status !== 'error' && (data?.counts?.lockedMailCount > 0 || data?.counts?.pendingStorageChargeCount > 0 || data?.counts?.actionRequiredBatchCount > 0) ? 'show-issues' : ''}`}
				>
					{status === 'success' && (
						<h6 className='sub-heading issues-heading'>
							{t('accountIssues.title', {
								count:
									data.counts.lockedMailCount +
									data.counts.pendingStorageChargeCount +
									data.counts.actionRequiredBatchCount,
							})}
						</h6>
					)}

					<div className='user-account-issues'>
						{status === 'success' && (
							<>
								{data?.counts?.lockedMailCount > 0 && (
									<LockedMailIssueEntry count={data.counts.lockedMailCount} />
								)}

								{data?.counts?.pendingStorageChargeCount > 0 && (
									<PendingStorageChargeIssueEntry count={data.counts.pendingStorageChargeCount} />
								)}

								{data?.counts?.actionRequiredBatchCount > 0 && (
									<ForwardingBatchesIssueEntry count={data.counts.actionRequiredBatchCount} />
								)}
							</>
						)}
					</div>
				</div>
			</div>
		</>
	);
}

export { AccountIssues };
